import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faAddressBook,
  faAngleDown,
  faAngleUp,
  faAngleLeft,
  faAngleRight,
  faArrowCircleLeft,
  faExternalLinkSquareAlt,
  faBars,
  faBarcode,
  faArrowsAltV,
  faCalendar,
  faCaretDown,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronCircleLeft,
  faChevronLeft,
  faChevronRight,
  faClock,
  faCog,
  faCopy,
  faDownload,
  faEllipsisV,
  faEnvelope,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faFileCsv,
  faGripLines,
  faHistory,
  faInfoCircle,
  faKey,
  faLayerGroup,
  faList,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faMinusSquare,
  faPaperclip,
  faPen,
  faPercent,
  faPhoneSquare,
  faUserTag,
  faPrint,
  faPlus,
  faSchool,
  faSearch,
  faSignOutAlt,
  faSitemap,
  faSlidersH,
  faSortDown,
  faSortUp,
  faStar,
  faStarHalf,
  faSync,
  faStepBackward,
  faStepForward,
  faMinus,
  faMapMarkerAlt,
  faChevronDown,
  faTable,
  faTimes,
  faTimesCircle,
  faTrash,
  faUpload,
  faUserCircle,
  faUsers,
  faVial,
  faCircle,
  faUserClock
} from "@fortawesome/free-solid-svg-icons";

import {
  faStar as farStar,
  faSquare,
  faDotCircle,
  faCircle as farCircle
} from "@fortawesome/free-regular-svg-icons";

library.add({
  faArrowsAltV,
  faExternalLinkSquareAlt,
  faAddressBook,
  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowCircleLeft,
  faBars,
  faBarcode,
  faCalendar,
  faCaretDown,
  faChartLine,
  faChartPie,
  faUserTag,
  faCheck,
  farCircle,
  faCheckCircle,
  faCheckSquare,
  faStar,
  faStarHalf,
  faSync,
  faStepBackward,
  faStepForward,
  faMinus,
  faChevronDown,
  faChevronCircleLeft,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClock,
  faCog,
  faCopy,
  faDotCircle,
  faDownload,
  faEllipsisV,
  faEnvelope,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faFileCsv,
  faGripLines,
  faMinusSquare,
  faHistory,
  faInfoCircle,
  faKey,
  faLayerGroup,
  faList,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faMapMarkerAlt,
  faPaperclip,
  faPen,
  faPercent,
  faPhoneSquare,
  faPlus,
  faPrint,
  faSchool,
  faSearch,
  faSignOutAlt,
  faSitemap,
  faSlidersH,
  faSortDown,
  faSortUp,
  faSquare,
  farStar,
  faTable,
  faTimes,
  faTimesCircle,
  faTrash,
  faUpload,
  faUserCircle,
  faUsers,
  faVial,
  faUserClock
}); // Include needed icons

Vue.component("font-awesome-icon", FontAwesomeIcon); // Register component globally
